import { render } from "./HomeGallery.vue?vue&type=template&id=184edc3f&scoped=true&lang=pug"
import script from "./HomeGallery.vue?vue&type=script&lang=ts"
export * from "./HomeGallery.vue?vue&type=script&lang=ts"

import "./HomeGallery.vue?vue&type=style&index=0&id=184edc3f&scoped=true&lang=sass"
script.render = render
script.__scopeId = "data-v-184edc3f"

export default script